<template>
    <div class="py-4">
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                <section class="text-gray-600 body-font">
                    <div class="container px-5 py-5 mx-auto">
                        <div class="flex flex-wrap w-full mb-5 flex-col">
                            <Accordion
                                :multiple="true"
                                :activeIndex="[0, 1, 2, 3, 4, 5, 6]"
                            >
                                <AccordionTab>
                                    <template #header>
                                        <span
                                            class="flex align-items-center gap-2 w-full"
                                        >
                                            <span
                                                class="font-bold white-space-nowrap"
                                                >Status</span
                                            >
                                        </span>
                                    </template>
                                    <StatusDokumenPengadaanInfo
                                        :status="
                                            dataViewDokumenPengadaan.status
                                        "
                                    />
                                </AccordionTab>
                                <AccordionTab>
                                    <template #header>
                                        <span
                                            class="flex align-items-center gap-2 w-full"
                                        >
                                            <span
                                                class="font-bold white-space-nowrap"
                                                >Data Utama</span
                                            >
                                        </span>
                                    </template>
                                    <ViewAttribute
                                        :dataViewDokumenPengadaan="
                                            dataViewDokumenPengadaan
                                        "
                                    ></ViewAttribute>
                                </AccordionTab>
                                <AccordionTab v-if="dataViewDokumenPengadaan.config.includes('dokumen_pengadaan_file')">
                                    <template #header>
                                        <span
                                            class="flex align-items-center gap-2 w-full"
                                        >
                                            <span
                                                class="font-bold white-space-nowrap"
                                                >File</span
                                            >
                                        </span>
                                    </template>
                                    <FileDisplay
                                        :existing_files="dataViewDokumenPengadaan.dokumen_pengadaan_file"
                                    />
                                </AccordionTab>
                                <AccordionTab v-if="dataViewDokumenPengadaan.config.includes('dokumen_pengadaan_jadwal')">
                                    <template #header>
                                        <span
                                            class="flex align-items-center gap-2 w-full"
                                        >
                                            <span
                                                class="font-bold white-space-nowrap"
                                                >Jadwal
                                            </span>
                                        </span>
                                    </template>
                                    <div class="p-4 lg:w-1/1 md:w-full">
                                        <DataTable :value="view_jadwals" responsiveLayout="scroll">
                                            <Column field="nama_jadwal" header="Nama Jadwal"></Column>
                                            <Column field="existing_jadwal.waktu_mulai" header="Tanggal Mulai">
                                                <template #body="slotProps">
                                                    {{ formatDate(slotProps.data.existing_jadwal.waktu_mulai) }}
                                                </template>
                                            </Column>
                                            <Column field="existing_jadwal.waktu_selesai" header="Tanggal Selesai">
                                                <template #body="slotProps">
                                                    {{ formatDate(slotProps.data.existing_jadwal.waktu_selesai) }}
                                                </template>
                                            </Column>
                                            <Column field="existing_jadwal.tempat" header="Tempat"></Column>
                                        </DataTable>
                                    </div>
                                </AccordionTab>
                                <AccordionTab v-if="dataViewDokumenPengadaan.config.includes('eligible_penyedia')">
                                    <template #header>
                                        <span
                                            class="flex align-items-center gap-2 w-full"
                                        >
                                            <span
                                                class="font-bold white-space-nowrap"
                                                >Eligible Penyedia</span
                                            >
                                        </span>
                                    </template>
                                    <ListPenyedia
                                        :list_penyedia="
                                            dataViewDokumenPengadaan.eligible_penyedia
                                        "
                                    />
                                </AccordionTab>
                            </Accordion>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import AppLayout from "@/Layouts/AppLayout.vue";
import BreadCrumb from "@/Components/BreadCrumb";
import Accordion from "primevue/accordion";
import Button from "primevue/button";
import AccordionTab from "primevue/accordiontab";
import JetLabel from "@/Jetstream/Label";
import StatusDokumenPengadaanInfo from "@/Components/StatusDokumenPengadaanInfo";
import Dropdown from "primevue/dropdown";
import FileDisplay from "./../partials/FileDisplay.vue";
import ListPenyedia from "./../partials/ListPenyedia.vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";

import ViewAttribute from "./../partials/ViewAttribute.vue";

export default defineComponent({
    components: {
        AppLayout,
        BreadCrumb,
        Accordion,
        AccordionTab,
        JetLabel,
        StatusDokumenPengadaanInfo,
        Dropdown,
        Button,
        FileDisplay,
        ListPenyedia,
        ViewAttribute,
        DataTable,
        Column,
    },
    props: {
        dataViewDokumenPengadaan: Object,
        header: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            // view_file_uploads: [],
            view_jadwals: [],
            form: {
                id_penyedia: this.dataViewDokumenPengadaan.id_penyedia,
            },
            penyediaOptions: [this.dataViewDokumenPengadaan.penyedia], // Load only the selected penyedia
        };
    },
    computed: {
        formattedTotalHPS() {
            return new Intl.NumberFormat("id-ID", {
                style: "currency",
                currency: "IDR",
            }).format(this.dataViewDokumenPengadaan.total_hps);
        },
    },
    mounted() {
        console.log("AA AA");
        console.log(
            "dataViewDokumenPengadaan || ViewPenyusunan",
            this.dataViewDokumenPengadaan
        );
        this.initializeFile();
        this.initializeJadwal();
    },
    methods: {
        initializeFile() {
            // this.dataViewDokumenPengadaan.dokumen_pengadaan_file.forEach(file => {
            //     this.view_file_uploads.push({
            //         id_file_dokumen_pengadaan: file.id,
            //         id_jadwal_pengadaan: file.id_jadwal_pengadaan,
            //         id_dokumen_pengadaan: file.id_dokumen_pengadaan,
            //         id_file_dokumen_prosedur: file.id_file_dokumen_prosedur,
            //         kode_file: file.kode_file,
            //         kode_prosedur: file.kode_prosedur,
            //         nama_file: file.nama_file,
            //         file_path: file.file_path,
            //         file_type: file.file_type,
            //         file_dokumen_type: file.file_dokumen_type,
            //         file_dokumen_type_id: file.file_dokumen_type_id,
            //         multiple: file.is_multiple === 1,
            //         new_file: [],
            //         existing_files: file.existing_files
            //     });
            // });
            // this.view_file_uploads =
            //     this.dataViewDokumenPengadaan.dokumen_pengadaan_file;
        },
        initializeJadwal() {
            this.view_jadwals =
                this.dataViewDokumenPengadaan.dokumen_pengadaan_jadwal;
        },
        formatDate(dateString) {
            if (!dateString) return '';
            const options = { 
                weekday: 'long', 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                timeZone: 'Asia/Jakarta'
            };
            return new Date(dateString).toLocaleDateString('id-ID', options);
        },
    },
});
</script>
